import { gql } from "@apollo/client";
import HandicappingFragments from "./HandicappingFragment";
import TimeformFragments from "./TimeformFragment";

export const TalentPickRaceFragment = {
  entry: gql`
    fragment BettingInterests on Race {
      bettingInterests {
        biNumber
        saddleColor
        numberColor
        currentOdds {
          numerator
          denominator
        }
        morningLineOdds {
          numerator
          denominator
        }
        runners {
          runnerId
          entityRunnerId
          scratched
          horseName
          jockey
          trainer
          ...timeformFragment
          ...handicappingFragment
        }
      }
    }
    ${HandicappingFragments.entry}
    ${TimeformFragments.entry}
  `
};
